import type { FC, ReactNode } from 'react'
import { ThemeProvider } from '@emotion/react'

import { useCurrentVariant } from 'hooks/useCurrentVariant'

const CurrentThemeProvider: FC<{
  children?: ReactNode
}> = ({ children }) => {
  const { currentVariant } = useCurrentVariant()
  return <ThemeProvider theme={currentVariant.theme}>{children}</ThemeProvider>
}

export default CurrentThemeProvider
